<script>
import CookieNotice from './BaseCookieNotice.vue';

export default {
  extends: CookieNotice,

  props: {
    wrapperClass: {
      type: String,
      default:
        'fixed left-5 md:left-auto right-5 bottom-5 rounded-sm bg-white shadow z-50 p-5 md:max-w-sm text-gray-700 animate-fade-in',
    },
    acceptBtnClass: {
      type: String,
      default: 'rounded-sm bg-black text-white font-semibold px-5 py-2.5',
    },
    rejectBtnClass: {
      type: String,
      default: 'rounded-sm border-2 border-black text-black font-semibold px-5 py-2.5',
    },
    resetSelector: {
      type: String,
      default: 'a[href="#cookies"]',
    },
  },

  methods: {
    handleAccepted() {
      document.body.classList.remove('cookies-rejected');
      document.body.classList.add('cookies-accepted');

      // Run GTM code
      if (window.gtm_code && !document.querySelector('[src^="https://www.googletagmanager.com"]')) {
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', window.gtm_code);
      }
    },
  },
};
</script>
